import * as ko from 'knockout';
import { DateTime } from 'luxon';
import { formatLongDate } from '../../shared/date-helpers';
import { SelectionType } from '../../shared/enums/selection-type';
import type { IGame } from '../../shared/interfaces/IGame';
import type { ITeam } from '../../shared/interfaces/ITeam';

export class CfbGame implements IGame {
  home: KnockoutObservable<ITeam>;
  away: KnockoutObservable<ITeam>;
  status: any;
  value: any;
  primeTimeNum: KnockoutObservable<number>;
  selectionMade: KnockoutObservable<boolean>;
  teamSelected: KnockoutObservable<string>;
  selectionType: KnockoutObservable<SelectionType>;
  TeamThatWon: KnockoutComputed<KnockoutObservable<ITeam>>;
  TeamThatLost: KnockoutComputed<KnockoutObservable<ITeam>>;
  GameClass: KnockoutComputed<string>;
  week: number;
  SortOrder: KnockoutComputed<number>;
  gameDate?: KnockoutObservable<DateTime>;
  gameDateShortDisplay: KnockoutComputed<string>;
  gameDateLongDisplay: KnockoutComputed<string>;
  gameKey: number;
  gameNum: KnockoutObservable<number>;
  gameScheduleNum: KnockoutObservable<number>;
  gameGuid: string;
  startTimeTBD: boolean;
  isConferenceGame: boolean;

  constructor(
    home: KnockoutObservable<ITeam> | any,
    away: KnockoutObservable<ITeam> | any,
    week: number,
    primeTimeType?: number,
    gameDate?: string,
    gameKey?: string,
    gameGuid?: string,
    gameScheduleNum?: number,
    startTimeTbd?: boolean,
    isConferenceGame?: boolean,
  ) {
    const self = this;
    self.gameGuid = gameGuid;
    self.home = home;
    self.away = away;
    self.week = week;
    self.gameNum = ko.observable(null);
    self.gameScheduleNum = ko.observable(null);
    self.startTimeTBD = startTimeTbd;
    self.isConferenceGame = isConferenceGame;

    if (gameScheduleNum != null) {
      self.gameScheduleNum(gameScheduleNum);
    }

    self.selectionMade = ko.observable(false);
    self.teamSelected = ko.observable('');
    self.selectionType = ko.observable(SelectionType.NONE);

    self.GameClass = ko.computed(() => {
      let retStr = '';
      if (self.selectionMade()) {
        retStr += 'selection-made ';
        if (self.selectionType() !== SelectionType.TIE && self.selectionType() !== SelectionType.NONE) {
          retStr += self.TeamThatWon()().TeamAbbreviation;
        } else if (self.selectionType() === SelectionType.TIE) {
          retStr += 'TIE';
        }
      }
      return retStr;
    });

    self.TeamThatWon = ko.pureComputed(() => {
      if (self.selectionMade() && (self.selectionType() !== SelectionType.NONE || self.selectionType() !== SelectionType.TIE)) {
        switch (self.selectionType()) {
          case SelectionType.AWAY_WIN: return self.away;
          case SelectionType.HOME_WIN: return self.home;
          default: return null;
        }
      }
    });

    self.TeamThatLost = ko.pureComputed(() => {
      if (self.selectionMade() && (self.selectionType() !== SelectionType.NONE || self.selectionType() !== SelectionType.TIE)) {
        switch (self.selectionType()) {
          case SelectionType.AWAY_WIN: return self.home;
          case SelectionType.HOME_WIN: return self.away;
          default: return null;
        }
      }
    });

    self.primeTimeNum = ko.observable(null);
    if (primeTimeType) {
      self.primeTimeNum(primeTimeType);
    }

    self.gameDate = ko.observable(null);
    if (gameDate) {
      self.gameDate(DateTime.fromISO(gameDate).toLocal());
    }
    if (gameKey) {
      self.gameKey = parseInt(gameKey, 10);
    }

    self.gameDateShortDisplay = ko.pureComputed(() => {
      if (self.startTimeTBD) {
        return self.gameDate() ? self.gameDate().toUTC().toFormat('ccc').slice(0, 2) + '*' : '';
      }
      return self.gameDate() ? self.gameDate().toFormat('ccc').slice(0, 2) : '';
    });

    self.gameDateLongDisplay = ko.pureComputed(() => {
      if (self.gameDate()) {
        const base = formatLongDate(self.gameDate()) + ' ' + self.gameDate().toFormat('ZZZZ');
        if (self.startTimeTBD) {
          return 'TBD ' + base;
        }
        return base;
      }
      return '';
    });

    self.SortOrder = ko.computed(() => {
      if (self.gameDate() && DateTime.isDateTime(self.gameDate())) {
        return self.gameDate().toMillis();
      }
      return 1;
    });
  }

  toString(): string {
    const away = ko.unwrap(this.away);
    const home = ko.unwrap(this.home);
    return `${away.TeamName} @${home.TeamName}`;
  }

  BothTeamNamesInGame(team1: string, team2: string): boolean {
    return (
      (this.away().TeamAbbreviation === team1 || this.away().TeamAbbreviation === team2) &&
      (this.home().TeamAbbreviation === team1 || this.home().TeamAbbreviation === team2)
    );
  }
}
